import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { RootState } from '../store'
import { DocumentBatch } from '../../models/DocumentBatch'
import { User } from '../../models/User'

interface DocumentBatchState {
  isLoading: boolean
  pollingEnabled: boolean
  documentBatch: DocumentBatch | null
  creator: User | null
  creatorIsLoading: boolean
  contact: User | null
  contactIsLoading: boolean
}

const initialState: DocumentBatchState = {
  isLoading: true,
  pollingEnabled: false,
  documentBatch: null,
  creator: null,
  creatorIsLoading: false,
  contact: null,
  contactIsLoading: false,
}

export const documentBatchSlice = createSlice({
  name: 'documentBatch',
  initialState,
  reducers: {
    setDocumentBatchLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload
    },
    setDocumentBatch: (state, action: PayloadAction<DocumentBatch>) => {
      state.documentBatch = action.payload
    },
    startDocumentBatchPolling: (state) => {
      state.pollingEnabled = true
    },
    stopDocumentBatchPolling: (state) => {
      state.pollingEnabled = false
    },
    setDocumentBatchCreator: (state, action: PayloadAction<User>) => {
      state.creator = action.payload
    },
    setDocumentBatchCreatorIsLoading: (state, action: PayloadAction<boolean>) => {
      state.creatorIsLoading = action.payload
    },
    setDocumentBatchContact: (state, action: PayloadAction<User>) => {
      state.contact = action.payload
    },
    setDocumentBatchContactIsLoading: (state, action: PayloadAction<boolean>) => {
      state.contactIsLoading = action.payload
    },
    resetDocumentBatch: () => initialState,
  },
})

export const {
  setDocumentBatchLoading,
  setDocumentBatch,
  startDocumentBatchPolling,
  stopDocumentBatchPolling,
  setDocumentBatchCreator,
  setDocumentBatchCreatorIsLoading,
  setDocumentBatchContact,
  setDocumentBatchContactIsLoading,
  resetDocumentBatch,
} = documentBatchSlice.actions

export const selectDocumentBatch = (state: RootState) => state.processDocument.documentBatch.documentBatch

export const selectDocumentBatchLoading = (state: RootState) => state.processDocument.documentBatch.isLoading

export const selectDocumentBatchPollingEnabled = (state: RootState) => state.processDocument.documentBatch.pollingEnabled

export const selectDocumentBatchCreator = (state: RootState) => state.processDocument.documentBatch.creator

export const selectDocumentBatchCreatorIsLoading = (state: RootState) => state.processDocument.documentBatch.creatorIsLoading

export const selectDocumentBatchContact = (state: RootState) => state.processDocument.documentBatch.contact

export const selectDocumentBatchContactIsLoading = (state: RootState) => state.processDocument.documentBatch.contactIsLoading
